/**
 * Logo Constants
 * Centralized logo configuration for consistent usage across the application
 */

// Logo variants
export const LOGO_VARIANTS = {
  FULL: 'full',       // Full logo with company name
  LONG: 'long',       // Horizontal long version (ideal for sidebars)
  ICON: 'icon'        // Icon only, no text (for compact spaces)
};

// Logo sizes
export const LOGO_SIZES = {
  SM: 'sm',          // 24px - Compact areas (mobile headers, small cards)
  MD: 'md',          // 32px - Default size (standard headers)
  LG: 'lg',          // 40px - Large headers (navigation bars)
  XL: 'xl'           // 64px - Hero sections (landing pages)
};

// Logo usage guidelines
export const LOGO_USAGE = {
  // Sidebar - Use long horizontal logo
  SIDEBAR: {
    variant: LOGO_VARIANTS.LONG,
    size: LOGO_SIZES.LG,
    maxWidth: '140px'
  },
  
  // Homepage hero section - Use full logo
  HOMEPAGE_HERO: {
    variant: LOGO_VARIANTS.FULL,
    size: LOGO_SIZES.XL
  },
  
  // Mobile header - Use icon only
  MOBILE_HEADER: {
    variant: LOGO_VARIANTS.ICON,
    size: LOGO_SIZES.MD
  },
  
  // Standard header - Use long logo
  HEADER: {
    variant: LOGO_VARIANTS.LONG,
    size: LOGO_SIZES.LG
  },
  
  // Footer - Use full logo
  FOOTER: {
    variant: LOGO_VARIANTS.FULL,
    size: LOGO_SIZES.SM
  }
};

// Accessibility
export const LOGO_ALT_TEXT = {
  DEFAULT: 'Classifi',
  FULL: 'Classifi - HTS Classification Platform',
  LONG: 'Classifi Logo',
  ICON: 'Classifi Icon'
};

// Default export
const logoConstants = {
  LOGO_VARIANTS,
  LOGO_SIZES,
  LOGO_USAGE,
  LOGO_ALT_TEXT
};

export default logoConstants;
